"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.PanelGroup = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

require("./index.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Node
// Style
var PanelGroup = function PanelGroup(_ref) {
  var children = _ref.children,
      topBloc = _ref.topBloc;

  var getTopBloc = function getTopBloc() {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "panel-group__topBloc"
    }, topBloc);
  };

  return /*#__PURE__*/_react.default.createElement("div", {
    className: "panel-group"
  }, topBloc ? getTopBloc() : null, children);
}; // Prop Types


exports.PanelGroup = PanelGroup;
PanelGroup.defaultProps = {
  topBloc: null
};
PanelGroup.propTypes = {
  children: _propTypes.default.node.isRequired,
  topBloc: _propTypes.default.node
};
var _default = PanelGroup;
exports.default = _default;